import en from "./languages/english";
// import es from "./languages/spanish";
import ar from "./languages/arabic";
// import fr from './languages/french'
export default {
  en,
  // es,
  ar,
  // fr
};
